/*
import React from 'react';
import { Card } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from 'react-router-dom';
import { faHome } from '@fortawesome/free-solid-svg-icons';
import { TodoList } from './TodoList.js';

const Gamma = () => {
  return (
    <Card className="text-center">
      <Card.Body className="p-5">
        <div className="display-1 text-300 fs-error">Gamma</div>
        <p>https://www.youtube.com/watch?v=wtlD7pWgu3c</p>
        <TodoList />
        <hr />
        <Link className="btn btn-primary btn-sm mt-3" to="/">
          <FontAwesomeIcon icon={faHome} className="me-2" />
          Vai alla Homepage
        </Link>
      </Card.Body>
    </Card>
  );
};

export default Gamma;
*/
import React from 'react';
import { Card } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from 'react-router-dom';
import { faHome } from '@fortawesome/free-solid-svg-icons';

const Gamma = () => {
  return (
    <Card className="text-center">
      <Card.Body className="p-5">
        <div className="display-1 text-300 fs-error">Gamma</div>
        <p className="lead mt-4 text-800 font-sans-serif fw-semibold">
          La pagina che hai richiesto è ancora in fase di redazione.
        </p>
        <hr />
        <Link className="btn btn-primary btn-sm mt-3" to="/">
          <FontAwesomeIcon icon={faHome} className="me-2" />
          Vai alla Homepage
        </Link>
      </Card.Body>
    </Card>
  );
};

export default Gamma;
